import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const GoToHomeLoader: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GoToHome" */ '../src/GoToHome.tsx')).GoToHome,
});
